/**
 * Stable comparison for Prisma/API user ids (UUID strings, optional casing drift).
 * @param {string|null|undefined} a
 * @param {string|null|undefined} b
 * @returns {boolean}
 */
export function isSameChatUserId(a, b) {
    if (a == null || b == null) return false;
    const sa = String(a).trim().toLowerCase();
    const sb = String(b).trim().toLowerCase();
    if (sa === 'undefined' || sa === 'null' || sb === 'undefined' || sb === 'null') {
        return false;
    }
    return sa.length > 0 && sb.length > 0 && sa === sb;
}
